import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-upload-transaction',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './upload-transaction.component.html',
  styleUrl: './upload-transaction.component.scss',
})
export class UploadTransactionComponent {
  processType = [{ name: 'Direct' }, { name: 'Queue' }];

  onProcessTypeSelect(data: { name: string }): void {
    console.log(data.name);
  }
}
